/* global axios */
import ApiClient from './ApiClient';

class TalkviaCustomDomain extends ApiClient {
  constructor() {
    super('talkvia_custom_domain', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  register(hostname) {
    return axios.post(this.url, { hostname });
  }

  verify() {
    return axios.post(`${this.url}/verify`);
  }

  remove() {
    return axios.delete(this.url);
  }
}

export default new TalkviaCustomDomain();
